module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"open_appt":"Open appt","before":"before"},"id":{"open_appt":"Buka appt","before":"sebelum"}}')
  delete Component.options._Ctor
}
